import React from "react";
import LegalLayout from "../../components/portal/LegalLayout";

export default function TrustAndSafetyPage() {
  return (
    <LegalLayout title="Trust & Safety" updated="Last updated: December 14, 2025">
      <p>
        At Antarctic Press, we take your trust and safety seriously. Our mission is to provide a secure and transparent platform where creators and backers can engage with confidence.
      </p>

      <h2>1. Platform Integrity</h2>
      <p>
        All projects undergo a review process to ensure compliance with our <a href="/terms-of-use">Terms of Use</a> and <a href="/privacy-policy">Privacy Policy</a>. We reserve the right to reject or remove campaigns that violate our guidelines or promote unsafe or deceptive practices.
      </p>

      <h2>2. User Verification</h2>
      <p>
        Creators are required to verify their identity and provide accurate information about their projects. This helps build a trustworthy environment and ensures accountability.
      </p>

      <h2>3. Payment Security</h2>
      <p>
        All transactions on Antarctic Press are processed securely through our trusted payment provider, Stripe. Your financial information is encrypted and never stored on our servers.
      </p>

      <h2>4. Backer Protections</h2>
      <p>
        On the Fund Go platform, we encourage creators to clearly communicate their project timelines, risks, and reward fulfillment plans. While backing a project carries inherent risk, we provide tools for transparency and updates throughout the campaign.
      </p>

      <h2>5. Reporting Violations</h2>
      <p>
        On the Fund Go platform, if you encounter a campaign or user that appears fraudulent, unsafe, or in violation of our policies, please report it immediately at <a href="mailto:support@antarcticpress.com">support@antarcticpress.com</a>. We review all reports promptly and take appropriate action.
      </p>

      <h2>6. Data Protection</h2>
      <p>
        We are committed to protecting your personal information in accordance with applicable privacy laws. Read our <a href="/privacy-policy">Privacy Policy</a> for more details.
      </p>

      <h2>7. Updates to This Policy</h2>
      <p>
        We may revise this Trust &amp; Safety page from time to time. Updates will be posted here with the date of revision.
      </p>
    </LegalLayout>
  );
}
